// NPM Imports
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LZLoader from "../../../../commonComponents/LZLoader";

// Components Imports

class SelectTemplateList extends Component {
  state = {
    tabCount: 0,
  };

  componentDidMount() {
    // To focus the first template after the templates load.
    if (this.props.templates.length > 0 && !this.props.loading) {
      this[`myRef_${this.state.tabCount}`].current.focus();
    }
  }

  handleKey = e => {
    const { templates, createDoc } = this.props;
    const { tabCount } = this.state;
    // handles the focusing when pressed all the arrow keys and enter.
    if (e.which === 13) {
      createDoc(templates[tabCount]);
    } else if (e.keyCode === 39 && Number(tabCount) < templates.length - 1) {
      this[`myRef_${Number(tabCount) + 1}`].current.focus();
    } else if (e.which === 37 && Number(tabCount) > 0) {
      this[`myRef_${Number(tabCount) - 1}`].current.focus();
    } else if (e.which === 40 && Number(tabCount) + 4 < templates.length) {
      this[`myRef_${Number(tabCount) + 4}`].current.focus();
    } else if (e.which === 38 && Number(tabCount) - 4 > -1) {
      this[`myRef_${Number(tabCount) - 4}`].current.focus();
    }
  };

  targetFocus = e => {
    // sets the state with the title of the focused div.
    this.setState({
      tabCount: e.target.tabIndex,
    });
  };

  render() {
    const { loading, templates } = this.props;

    // Making refs for all the template divs.
    if (!this.props.loading) {
      this.props.templates.forEach((elem, index) => {
        this[`myRef_${index}`] = React.createRef();
      });
    }

    // Show loading message
    if (loading) {
      return (
        <div className="select-template-list">
          <LZLoader label="Loading Templates..." />
        </div>
      );
    }

    return (
      <div className="select-template-list-wrapper">
        <div className="select-template-list">
          {/* --------------- Create/Upload Document btn section --------------- */}
          <div
            className="assetcreatedoc-custom-doc-ico"
            onClick={this.props.createDoc}
            onKeyPress={() => {}}
            role="button"
            tabIndex="0">
            <i>
              <FontAwesomeIcon icon={["far", "plus"]} />
            </i>
            <span>Create blank document</span>
          </div>
          {/* --------------- Template List section --------------- */}
          {templates.map((template, index) => (
            <div
              key={template.id}
              className="template-list-create-template"
              role="button"
              onKeyDown={e => this.handleKey(e, template, index)}
              tabIndex={index}
              ref={this[`myRef_${index}`]}
              onFocus={this.targetFocus}
              title={template.title}
              id={template.title.replace(/ +/g, "-").toLowerCase()}
              onClick={() => this.props.createDoc(template)}
              onKeyPress={() => {}}>
              <div className="template-list-create-templatecard">
                <img src={`${template.thumbnail}`} alt={`${template.title}`} />
                {template.template_type === "form" && (
                  <div className="template-list-create-badgewrapper">
                    <span className="template-list-create-badge">Form</span>
                  </div>
                )}
                {template.is_pdf_document && (
                  <div className="template-list-create-badgewrapper">
                    <span className="template-list-create-badge-pdf">PDF</span>
                  </div>
                )}
              </div>
              <div className="template-list-create-templatecardname">
                {template.title}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default SelectTemplateList;
